$(function () {
    $('.masonry:not([data-plugin="infinite-load"])').each(function () {
        $(this).masonry({
            itemSelector: '.masonry-column'
        });
    });
});
